import React, { Component } from 'react';
import { userLogout } from '../../common/globals';

class StatusCode503 extends Component {
    _onClickOk = async () => {
      await userLogout(true);
    }

    render() {
      return (
        <div
          className="modal fade theme-modal qty-modal" id="statusCode503Modal"
          tabIndex="-1" aria-labelledby="statusCode503ModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content">
              <div className="modal-body">
                <p id="statusCode503Modal-message">System temporarily down for maintenance.</p>
              </div>
              <div className="modal-footer">
                <div className="row gx-2 button-wrap">
                  <div className="col-12">
                    <button
                      type="button" className="btn btn-link w-100 pt-3"
                      data-bs-dismiss="modal"
                      onClick={this._onClickOk}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
}

export default StatusCode503;
